function matchFilterString(string: string | undefined, filterString: string | undefined, options?: { exact: boolean }) {
  if (!filterString) return true
  if (!string) return false

  const { exact } = options || {}

  if (exact){
    return string === filterString
  }

  return string.toLowerCase().includes(filterString.toLowerCase())
}

export default matchFilterString
